import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Zap, Shield, Users, Clock, ThumbsUp } from 'lucide-react';
const benefits = [{
  icon: CheckCircle2,
  title: 'Expertos Certificados',
  desc: 'Personal CPO Certified altamente capacitado.'
}, {
  icon: Zap,
  title: 'Tecnología Avanzada',
  desc: 'Equipos modernos para diagnósticos precisos.'
}, {
  icon: Shield,
  title: 'Productos Seguros',
  desc: 'Químicos y materiales de la más alta calidad.'
}, {
  icon: Users,
  title: 'Equipo Uniformado',
  desc: 'Personal identificado y completamente asegurado.'
}, {
  icon: Clock,
  title: 'Respuesta Rápida',
  desc: 'Atención oportuna en todo Central Florida.'
}, {
  icon: ThumbsUp,
  title: 'Garantía de Satisfacción',
  desc: 'No descansamos hasta que su piscina esté perfecta.'
}];
export function WhyChooseUs() {
  return <section className="py-20 bg-white" data-id="element-266">
      <div className="container mx-auto px-4 md:px-6" data-id="element-267">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-268">
          <div className="w-full lg:w-1/3" data-id="element-269">
            <motion.h2 initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-pool-600 font-semibold tracking-wider uppercase text-sm mb-2" data-id="element-270">
              Por Qué Elegirnos
            </motion.h2>
            <motion.h3 initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-3xl md:text-4xl font-bold text-navy-900 mb-6" data-id="element-271">
              La Diferencia Innova Pools
            </motion.h3>
            <motion.p initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-gray-600 mb-8 text-lg" data-id="element-272">
              Nos enorgullece ofrecer un servicio que combina experiencia
              técnica con una atención al cliente excepcional. Su tranquilidad
              es nuestra prioridad.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} data-id="element-273">
              <img src="https://i.imgur.com/2fq6zum.png" alt="Innova Pools Logo" className="h-20 opacity-80 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-274" />
            </motion.div>
          </div>

          <div className="w-full lg:w-2/3" data-id="element-275">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10" data-id="element-276">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex gap-4" data-id="element-277">
                  <div className="flex-shrink-0 mt-1" data-id="element-278">
                    <div className="w-12 h-12 rounded-full bg-pool-50 flex items-center justify-center text-pool-600" data-id="element-279">
                      <benefit.icon size={24} data-id="element-280" />
                    </div>
                  </div>
                  <div data-id="element-281">
                    <h4 className="text-xl font-bold text-navy-900 mb-2" data-id="element-282">
                      {benefit.title}
                    </h4>
                    <p className="text-gray-600" data-id="element-283">{benefit.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}